import React from 'react'
import { CircularProgress } from '@material-ui/core'
import credit_card_brands from '~/assets/images/credit_card_brands.png'
import PaymentButton from '../payment_button'

export default function RenderPayment({
    item,
    onCreateInvoice,
    isMobile = false,
    loading = false,
}) {
    if (item.isPaid) {
        return (
            <>
                <strong>Pago</strong>
                {!!item.dtPagto && (
                    <div>
                        Valor pago: R$ {item.valueWithFare.replace('.', ',')}
                    </div>
                )}
                {!!item.dtPagto && <div>Pagto: {item.dtPagto}</div>}
            </>
        )
    }
    return (
        <div className="flex flex-col justify-center items-center gap-2 md:gap-0 md:w-64 md:text-center">
            {loading ? (
                <>
                    <CircularProgress size={16} />{' '}
                    <strong>{item.cardMessage}</strong>
                </>
            ) : (
                <>
                    <div className="mt-3 md:mb-2 md:mt-0">
                        <strong>Em aberto</strong>
                    </div>

                    <PaymentButton item={item} />

                    <button
                        type="button"
                        className="payWithCard"
                        onClick={() => onCreateInvoice(item, isMobile)}
                    >
                        <img
                            src={credit_card_brands}
                            alt="Pagamento com cartão de crédito"
                        />
                    </button>
                </>
            )}
        </div>
    )
}
